import { render, staticRenderFns } from "./fbSearchSetting.vue?vue&type=template&id=127bb856&"
import script from "./fbSearchSetting.vue?vue&type=script&lang=js&"
export * from "./fbSearchSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports